import { THEME_SETTINGS } from "@theme-settings";
import { observable, action } from "mobx";

export class MaintenanceStore {
	//winter time - time set inside variable + 01:00 is when maintenance will be on/off
	//summer time - time set inside variable + 02:00 is when maintenance will be on/off
	private readonly startTime: Date = new Date("2026-10-20T04:00:00Z");
	private readonly endTime: Date = new Date("2026-10-20T15:00:00Z");

	public readonly textDate: string = "20.10";
	public readonly textTimeFrom: string = "07:00";
	public readonly textTimeTo: string = "08:00";

	public readonly maintenanceTitle: string = "MAINTENANCE.TITLE";
	public readonly maintenanceDateMessage: string = "";
	public readonly maintenanceDetailsMessage: string =
		"MAINTENANCE.JT_UPGRADE";

	public readonly oasisMaintenanceDateMessage: string =
		"MAINTENANCE.OASIS_MESSAGE";

	private readonly checkIntervalMs: number = 60 * 1000;

	private timerId: number | null = null;

	@observable
	public isVisible = false;

	constructor() {}

	public onInitialize(): void {
		if (this.timerId !== null) return;

		if (!THEME_SETTINGS.isMaintenanceEnabled) {
			this.isVisible = false;
			return;
		}

		const now = new Date();

		if (now > this.endTime) {
			this.isVisible = false;
			return;
		}

		this.checkVisibility();
		this.startTimer();
	}

	@action
	private checkVisibility(): void {
		if (!THEME_SETTINGS.isMaintenanceEnabled) {
			this.isVisible = false;
			return;
		}

		const now = new Date();

		if (now > this.endTime) {
			this.isVisible = false;
			this.stopTimer();
			return;
		}

		this.isVisible = now >= this.startTime;
	}

	private startTimer(): void {
		if (this.timerId !== null) return;

		this.timerId = window.setInterval(() => {
			this.checkVisibility();
		}, this.checkIntervalMs);
	}

	private stopTimer(): void {
		if (this.timerId !== null) {
			clearInterval(this.timerId);
			this.timerId = null;
		}
	}

	public onDispose(): void {
		if (this.timerId !== null) {
			this.stopTimer();
		}
	}
}
